import React, { useContext } from 'react'
import classNames from 'classnames'
import SignupContext from 'modules/react/signup/SignupContext'

export default function FormElementError ({ children, name, withDescription = true }) {

  const { errors, getFormValue } = useContext(SignupContext)

  const childrenWithProps = React.Children.map(children, child => {
    const hasError = errors && name in errors

    if (React.isValidElement(child)) {
      return (
        <>
          {React.cloneElement(child, {
            defaultValue: child.props.defaultValue || getFormValue(name),
            className: classNames({
              error: hasError,
              [child.className]: true,
            }),
            name: name,
          })}
          {hasError && withDescription && <span className="input-wrap__error">{errors[name]}</span>}
        </>
      )
    }
    return child
  })

  return childrenWithProps
}